import { formatDateString } from './formatString';

const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

export const getIsoDate = (input) => {
  if (typeof input === 'string' && input.match(/^(\d{4})-(\d{2})-(\d{2})$/)) {
    return input;
  }
  return formatDateString(input, 'YYYY-MM-DD');
};

export function getCurrentDay() {
  const date = new Date();
  return `${date.getDate()}\u00a0${months[date.getMonth()]}`;
}

export function getRuLocatedDateWithMonth(value) {
  const formatedDate = getIsoDate(value);
  const date = new Date(formatedDate);
  return `${date.getDate()}\u00a0${months[date.getMonth()]}`;
}
